import React from 'react';

import { experience } from '../../data/experience';

export function ExperienceTimeline() {
  return (
    <section className="experience-section" id="experience" aria-labelledby="experience-title">
      <div className="section-heading">
        <p className="eyebrow">2020 — Present</p>
        <h2 id="experience-title">Experience</h2>
      </div>
      <ol className="career-timeline">
        {experience.map((role) => (
          <li className={`career-role${role.current ? ' career-role-current' : ''}`} key={role.company}>
            <div className="career-date">{role.period}{role.current && <span className="current-label">Current</span>}</div>
            <article className="career-content">
              <h3>{role.company}</h3>
              <p className="career-title">{role.title}</p>
              <p className="career-summary">{role.summary}</p>
              <details className="career-details">
                <summary>Core contributions <span className="visually-hidden"> at {role.company}</span>
                  <span aria-hidden="true">+</span>
                </summary>
                <div className="contributions">
                  {role.contributions.map((item) => (
                    <div className="contribution" key={item.title}>
                      <h4>{item.title}</h4>
                      <p>{item.text}</p>
                    </div>
                  ))}
                  {role.recognition && <p className="career-recognition">{role.recognition}</p>}
                  <ul className="technology-tags" aria-label={`${role.company} technologies`}>
                    {role.technologies.map((technology) => <li key={technology}>{technology}</li>)}
                  </ul>
                </div>
              </details>
            </article>
          </li>
        ))}
      </ol>
    </section>
  );
}
